import { render } from "./AltaRolForm.vue?vue&type=template&id=8505858e&scoped=true"
import script from "./AltaRolForm.vue?vue&type=script&lang=js"
export * from "./AltaRolForm.vue?vue&type=script&lang=js"

import "./AltaRolForm.vue?vue&type=style&index=0&id=8505858e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8505858e"]])

export default __exports__